import { render, staticRenderFns } from "./SearchResultsOpportunity.vue?vue&type=template&id=2c620e32&scoped=true&"
import script from "./SearchResultsOpportunity.vue?vue&type=script&lang=js&"
export * from "./SearchResultsOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsOpportunity.vue?vue&type=style&index=0&id=2c620e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c620e32",
  null
  
)

export default component.exports